<template>
	<div>
		<span class="dde__input-caption">Response code</span>
		<input
			v-model="updateData.code"
			type="text"
			autocomplete="off"
			maxlength="3"
		/>

		<span class="dde__input-caption">Description</span>
		<input
			v-model="updateData.description"
			type="text"
			autocomplete="off"
			maxlength="255"
		/>
	</div>
</template>

<script>
export default {
	props: { updateData: Object }
};
</script>